import { jwtDecode } from 'jwt-decode';
import { IJwtPayload, IUserInfo } from '../interfaces/user';
import { EUserRole } from '@/enums/EUserRole';

const getuserInfo = (token: string) => {
  if (!token) return null;
  const decodedToken = jwtDecode<IJwtPayload>(token);
  const userInfo: IUserInfo = {
    id: decodedToken.nameid,
    name: decodedToken.unique_name,
    email: decodedToken.email,
    role: (decodedToken.role as EUserRole) ?? EUserRole.Employee,
    permissions:
      typeof decodedToken.permissions === 'string'
        ? [decodedToken.permissions]
        : decodedToken.permissions,
    bu: Number(decodedToken.bu) || null,
    buName: decodedToken.buName,
  };
  return userInfo;
};

export { getuserInfo };
